import { render, staticRenderFns } from "./Fixing.vue?vue&type=template&id=b9ff9d9a&scoped=true"
import script from "./Fixing.vue?vue&type=script&lang=js"
export * from "./Fixing.vue?vue&type=script&lang=js"
import style0 from "./Fixing.vue?vue&type=style&index=0&id=b9ff9d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ff9d9a",
  null
  
)

export default component.exports